module.exports = __webpack_public_path__ + "img/title.f4f9c2a0.png";